import React from "react";
import PageHero from "@/components/PageHero";
import { CONTACT } from "@/lib/api";

/*
  Impressum / Imprint — keeps the German legal text verbatim
  as required for a German company website (§5 TMG).
*/
export default function Impressum() {
  return (
    <div data-testid="page-impressum">
      <PageHero
        eyebrow="§5 TMG"
        title={
          <>
            Impressum <span className="text-[color:var(--zp-text-3)]">/ Imprint</span>
          </>
        }
        subtitle="Angaben gemäß § 5 TMG · Legal disclosure for Zopran Global Logistics Group."
      />

      <section className="relative pb-24">
        <div className="max-w-4xl mx-auto px-6 sm:px-8">
          <div className="zp-card p-8 sm:p-12 space-y-10">
            {/* Company block */}
            <div>
              <h2 className="font-display text-2xl tracking-tight">Zopran GmbH</h2>
              <p className="text-[color:var(--zp-text-2)] mt-2 text-sm leading-relaxed">
                {CONTACT.address}<br />
                Deutschland · Germany
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mt-5 text-sm">
                <div>
                  <div className="zp-label">Telefon</div>
                  <a href={`tel:${CONTACT.phone}`} className="text-[color:var(--zp-navy)] hover:underline">
                    {CONTACT.phone}
                  </a>
                </div>
                <div>
                  <div className="zp-label">E-Mail</div>
                  <a href={`mailto:${CONTACT.email}`} className="text-[color:var(--zp-navy)] hover:underline">
                    {CONTACT.email}
                  </a>
                </div>
              </div>
            </div>

            <Divider />

            <Block heading="Angaben gemäß § 5 TMG">
              <p>
                Diese Webseite wird betrieben durch die Zopran GmbH mit Sitz in
                Darmstadt, Deutschland. Die Zopran GmbH ist Teil der{" "}
                <strong>Zopran Global Logistics Group</strong> gemeinsam mit den
                Schwestermarken AeroShip Global OÜ und ShipMyParcels.com.
              </p>
            </Block>

            <Block heading="Haftung für Inhalte">
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
                Nutzung von Informationen nach den allgemeinen Gesetzen
                bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
                jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
                Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                Rechtsverletzungen werden wir diese Inhalte umgehend
                entfernen.
              </p>
            </Block>

            <Block heading="Haftung für Links">
              <p>
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir
                für diese fremden Inhalte auch keine Gewähr übernehmen. Für
                die Inhalte der verlinkten Seiten ist stets der jeweilige
                Anbieter oder Betreiber der Seiten verantwortlich. Die
                verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
                mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
                waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine
                permanente inhaltliche Kontrolle der verlinkten Seiten ist
                jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung
                nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen
                werden wir derartige Links umgehend entfernen.
              </p>
            </Block>

            <Block heading="Urheberrecht">
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen
                der schriftlichen Zustimmung des jeweiligen Autors bzw.
                Erstellers. Downloads und Kopien dieser Seite sind nur für
                den privaten, nicht kommerziellen Gebrauch gestattet. Soweit
                die Inhalte auf dieser Seite nicht vom Betreiber erstellt
                wurden, werden die Urheberrechte Dritter beachtet.
                Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
                Sollten Sie trotzdem auf eine Urheberrechtsverletzung
                aufmerksam werden, bitten wir um einen entsprechenden
                Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir
                derartige Inhalte umgehend entfernen.
              </p>
            </Block>

            <Divider />

            <p className="text-xs text-[color:var(--zp-text-3)]">
              © Copyright {new Date().getFullYear()}. Alle Rechte vorbehalten ·
              Zopran Global Logistics Group.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

function Block({ heading, children }) {
  return (
    <section>
      <h3 className="font-display text-xl tracking-tight mb-3">{heading}</h3>
      <div className="text-sm leading-relaxed text-[color:var(--zp-text-2)] space-y-3">
        {children}
      </div>
    </section>
  );
}

function Divider() {
  return <div className="zp-divider" />;
}
